export function get_save_shopify_pr_id(bagaz){
    return new Promise(async function(resolve,reject){
        //most likely we will check shops api to see if such item has not been uploaded already
        //if not, then we send the load to shopify
        //as we amend the local db table with what has been send
        bagaz.l=1
        var request=new Request('https://upcscanningapp.azurewebsites.net/api/get_save_shopify_pr_id', {            
            method:'POST',
            headers: new Headers({'Accept': 'application/json',
            'Content-Type':'application/json'}),
            body:JSON.stringify(bagaz)
            })
        //we make a request
        fetch(request)
        //we get response, in form of json
            .then(response=>response.json())
            .then(response=>{
                console.log('sku returns',response)
                resolve(response)
            })
        })
    }